import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

export const SmallListViewSkeleton = () => (
	<React.Fragment>
		<div className="w-5/12 pr-2">
			<Skeleton height={200} className="mb-4" />
			<Skeleton count={3} />
		</div>

		<div className="w-7/12">
			<Skeleton height={40} width={100} />
			{new Array(4).fill(0).map(() => (
				<React.Fragment key={uuidv4()}>
					<Skeleton className="mt-3" />
					<Skeleton width="50%" />
					<Skeleton />
					<Skeleton width="50%" />
				</React.Fragment>
			))}
			<Skeleton height={40} />
		</div>
	</React.Fragment>
);

export default SmallListViewSkeleton;
